
<page-title></page-title>
<div class="ng-wrapper">
  <router-outlet></router-outlet>
</div>
